module.exports = __webpack_public_path__ + "static/media/CanBeSeenBadOptimized.b643d8db.webp";